import React from 'react';
import { connect } from 'react-redux';

export const USER_ROLES = {
  MASTER_ADMIN: 1,
  ADMIN: 2,
  MANAGER: 3,
  STAFF: 4,
  MANAGER_GUEST: 5,
  USER_GUEST: 6,
};

export const MASTER_ADMIN_ROLES = [USER_ROLES.MASTER_ADMIN];

export const ADMIN_USER_ROLES = [USER_ROLES.MASTER_ADMIN, USER_ROLES.ADMIN];

export const USER_ROLE_IDS = {
  1: USER_ROLES.MASTER_ADMIN,
  2: USER_ROLES.ADMIN,
  3: USER_ROLES.MANAGER,
  4: USER_ROLES.STAFF,
  5: USER_ROLES.MANAGER_GUEST,
  6: USER_ROLES.USER_GUEST,
};

export const MANAGER_USER_ROLES = [USER_ROLES.MASTER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER];

export const INTERNAL_USER_ROLES = [
  USER_ROLES.MASTER_ADMIN,
  USER_ROLES.ADMIN,
  USER_ROLES.MANAGER,
  USER_ROLES.STAFF,
];

export const EXTERNAL_USER_ROLES = [USER_ROLES.MANAGER_GUEST, USER_ROLES.USER_GUEST];

export const ACCOUNT_ROLES = {
  ACCOUNT_LEAD: 'ACCOUNT LEAD',
  WORKSTREAM_LEAD: 'WORKSTREAM LEAD',
};

// Usage without hooks
export const checkAccess = ({ user, allowedRoles }) => {
  if (allowedRoles && allowedRoles.length > 0) {
    return allowedRoles.includes(user.userRole);
  }

  return true;
};

export const checkIfInternal = (user) => {
  return checkAccess({ user, allowedRoles: INTERNAL_USER_ROLES });
};

export const checkIfExternal = (user) => {
  return checkAccess({ user, allowedRoles: EXTERNAL_USER_ROLES });
};

export const checkIfAdmin = (user) => {
  return checkAccess({ user, allowedRoles: ADMIN_USER_ROLES });
};

export const useAuthorization = (loggedUser) => {
  const user = loggedUser && loggedUser.data;

  if (!user) {
    throw Error('User does not exist!');
  }

  const checkAccess = React.useCallback(
    ({ allowedRoles }) => {
      if (allowedRoles && allowedRoles.length > 0) {
        return allowedRoles.includes(user.userRole);
      }

      return true;
    },
    [user.userRole]
  );

  return { checkAccess, role: user.role };
};

@connect((store) => {
  return {
    loggedUser: store.loggedUser,
  };
})
export class Authorization extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      loggedUser,
      policyCheck,
      allowedRoles,
      forbiddenFallback = null,
      children,
    } = this.props;

    // let canAccess = false;
    let canAccess = !!loggedUser.data;

    if (allowedRoles) {
      canAccess = checkAccess({ user: loggedUser.data, allowedRoles });
    }

    if (typeof policyCheck !== 'undefined') {
      canAccess = policyCheck;
    }

    return <React.Fragment>{canAccess ? children : forbiddenFallback}</React.Fragment>;
  }
}
